export default __webpack_public_path__ + "static/media/icon5.864c6c14.svg";